import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  OutlinedInput,
} from "@mui/material";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { rem } from "assets/js/common";
import Divider from "@mui/material/Divider";
import React, { useEffect, useState } from "react";
import Loading from "components/ui/loading";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";
import { Cookies } from "react-cookie";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  couponRegist: {
    "& .coupon-list": {
      padding: `${rem(30)} ${rem(30)} ${rem(60)}`,
    },
    "& .regist-form": {
      padding: `${rem(50)} ${rem(30)} ${rem(20)} ${rem(30)}`,
      "& button": {
        marginTop: rem(10),
      },
    },
  },
}));

export default function RegistCoupon() {
  const classes = useStyles();

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [couponImg, setCouponImg] = useState("");
  const [listData, setListData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const history = useHistory();

  useEffect(() => {
    fetchData();
  }, []);

  window.appBackKeyHandle = () => {
    if (alert) {
      setAlert(false);
    } else {
      history.goBack();
    }
  };

  const fetchData = () => {
    return new Promise((resolve) => {
      setFetching(true);
      loadCouponSeq();
      loadList();
      resolve(true);
    });
  };

  const loadCouponSeq = () => {
    axios
      .get("/api/cp/coupon-image/get")
      .then((res) => {
        setCouponImg(res.data.data.couponImage.imgUrl);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  const loadList = () => {
    axios
      .get("/api/cp/coupon/add-list", {
        params: {
          schTp: favInfo ? favInfo.visibleTp : "1",
          storeCode: storeCode,
          sordFld: "dday",
        },
      })
      .then((res) => {
        setListData(res.data.data);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  const downloadAll = () => {
    axios
      .post("/api/cp/coupon/all-add-coupon", {
        storeCode: storeCode,
      })
      .then((res) => {
        setAlertMsg("쿠폰을 다운로드 했습니다.");
        setAlert(true);
        loadList();
      });
  };

  const [alertMsg, setAlertMsg] = useState("");

  const registCoupon = () => {
    axios
      .post("/api/cp/coupon/add", {
        promotionSubId: couponNum,
      })
      .then((res) => {
        setAlertMsg("쿠폰등록이 완료 되었습니다.");
        setAlert(true);
        loadList();
      })
      .catch((error) => {
        setAlertMsg("유효하지 않은 쿠폰번호입니다.");
        setAlert(true);
      });
  };

  const [couponNum, setCouponNum] = useState("");
  const [alert, setAlert] = useState(false);

  const downloadCoupon = (item) => {
    axios
      .post("/api/cp/coupon/add-coupon", {
        promotionSubId: item.promotionSubId,
        couponCode: item.couponCode,
        storeCode: storeCode,
      })
      .then((res) => {
        setAlertMsg("My 쿠폰에서 확인하세요.");
        setAlert(true);
        loadList();
      });
  };

  return (
    <>
      <Loading open={fetching} />
      <PullToRefresh
        onRefresh={fetchData}
        pullingContent={false}
        refreshingContent={<Spinner />}
      >
        <div className={classes.couponRegist}>
          <div className="coupon-list bg-grey">
            <Box display="flex" justifyContent="flex-end" mb={3}>
              <Button
                onClick={downloadAll}
                disabled={listData.length == 0}
                style={{ fontSize: rem(13), fontWeight: 400 }}
              >
                모두받기
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/icon-download${
                    listData.length == 0 ? "-disabled" : ""
                  }.svg`}
                  style={{ width: "18px", height: "18px" }}
                />
              </Button>
            </Box>
            {listData.length > 0 ? (
              <>
                <ul>
                  {listData.map((item, i) => (
                    <li
                      key={i}
                      className="coupon-item"
                      style={{
                        backgroundImage: `url(${couponImg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "100% 178px",
                      }}
                    >
                      <div className="item-wrap">
                        <div className="contents">
                          <div>
                            <Chip
                              label={`D-${item.dday}`}
                              color="primary"
                              className="dday"
                              size="small"
                            />
                            <p className="tit">{item.title1}</p>
                            <p className="tit-sub">{item.couponNm}</p>
                          </div>

                          <p className="date">
                            ~{moment(item.endDate).format("YY.MM.DD")}
                          </p>
                        </div>

                        <div
                          className="side"
                          onClick={() => {
                            downloadCoupon(item);
                          }}
                        >
                          <Button>
                            <img
                              src={`${
                                process.env.PUBLIC_URL
                              }/images/icon/icon-download.svg`}
                              style={{ width: "36px", height: "36px" }}
                            />
                          </Button>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <>
                <div
                  className="nodata"
                  style={{
                    height: "auto",
                    margin: `${rem(20)} ${rem(0)} ${rem(6)}`,
                  }}
                >
                  <Box className="illust">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`}
                    />
                  </Box>
                  <p className="color-info">조회된 내역이 없습니다</p>
                </div>
              </>
            )}
          </div>
          <div className="regist-form">
            <FormControl>
              <OutlinedInput
                value={couponNum}
                onChange={(e) => {
                  setCouponNum(e.target.value);
                }}
                placeholder="쿠폰번호를 입력해주세요."
              />
            </FormControl>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              disabled={!couponNum}
              onClick={registCoupon}
            >
              등록하기
            </Button>
          </div>
          <Divider style={{ marginTop: rem(30) }} />
          <Box className="notice is-bottom">
            <p className="title">
              <i className="ico-noti" />
              유의사항
            </p>
            <ul className="list list-dot color-info font-14">
              <li>쿠폰번호 8자리를 입력해주세요</li>
              <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
              <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
              <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
            </ul>
          </Box>

          <Dialog
            open={alert}
            onClose={() => {
              setAlert(false);
            }}
            className="alert-wrap"
            aria-labelledby="alert-dialog-title"
          >
            <DialogTitle className="tit-center" id="alert-dialog-title">
              알림
            </DialogTitle>
            <DialogContent>
              <DialogContentText>{alertMsg}</DialogContentText>
            </DialogContent>
            <DialogActions className="btn-center">
              <Button
                onClick={() => {
                  setAlert(false);
                }}
                autoFocus
                variant="contained"
                color="primary"
                size="small"
              >
                확인
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </PullToRefresh>
    </>
  );
}
